import React, { useEffect, useRef, useState } from "react";
import {
    Button,
    Table,
    Overlay,
    Popover,
    Col,
    Form,
    Row,
    Alert,
    OverlayTrigger,
} from "react-bootstrap";
import Loader from "../../../Loader/Loader";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import moment from "moment";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import PricingModel from "./PricingModel";
import RateModel from "./RateModel";
import trendingup from "../../../../Assets/Images/Revenue-management/trending-up.svg";
import trendingdown from "../../../../Assets/Images/Revenue-management/trending-down.svg";
import DemandScore_High from "../../../../Assets/Images/Revenue-management/DemandScore_High.svg";
import DemandScore_Low from "../../../../Assets/Images/Revenue-management/DemandScore_Low.svg";
import DemandScore_Moderate from "../../../../Assets/Images/Revenue-management/DemandScore_Moderate.svg";
import DemandScore_VeryHigh from "../../../../Assets/Images/Revenue-management/DemandScore_VeryHigh.svg";
import DemandScore_VeryLow from "../../../../Assets/Images/Revenue-management/DemandScore_VeryLow.svg";
import FlagPopup from "../DailySummary/FlagPopup";
import { MultiSelect } from "primereact/multiselect";

export const PricingLadder = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const [DaysIntervals, setDaysIntervals] = useState(7);



    const { snapshottitle, propertyCode, snapshotId } = useParams();
    const [modelView, setModelView] = useState({
        IsDisplay: false,
        Target: null,
        Position: "bottom",
    });
    const [rateModelView, setRateModelView] = useState({
        IsDisplay: false,
        Target: null,
        Position: "bottom",
    });
    const [modelData, setModelData] = useState(false);
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );

    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );

    const [tblids, settblids] = useState({
        id1: commonService.GenerateGUID(),
    });

    const widgetDetailRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };

    const [lyForecastData, setLYForecastData] = useState([]);
    const [WidgetData, setWidgetData] = useState([]);

    const [DisplayLoading, setDisplayLoading] = useState(false);




    const GetWidgetData = async () => {
        setDisplayLoading(true);
        await getFLAG_MECHANISM();
        let wd = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DYNAMIC_PRICING.SNP_PRICING_GRID,
                body: {
                    asofdate: para?.asOfDate,
                    propertycode: para?.propertyCode,
                    days: DaysIntervals,
                    marketsegment: selectedMarketSegment ? selectedMarketSegment.join(",") : "",
                    ratecode: selectedRoomType ? selectedRoomType.join(",") : ""
                },
            },
            false
        );

        let wd_response = apiResponse(false, wd);

        if (wd_response?.isValidate) {
            setWidgetData(wd_response.data.data);
        } else {
            setWidgetData([]);
        }
        setDisplayLoading(false);
    };

    const [WidgetDataStayDate, setWidgetDataStayDate] = useState([]);

    const [WidgetDataOccupancySlab, setWidgetDataOccupancySlab] = useState([]);

    const [WidgetDataTotalOccupancy, setWidgetDataTotalOccupancy] = useState([]);

    useEffect(() => {
        if (WidgetData && WidgetData.length !== 0) {
            const uniqueStayDates = [
                ...new Set(WidgetData.map((item) => item.StayDate)),
            ];
            const uniqueOccupancySlabs = [
                ...new Set(WidgetData.map((item) => item.occupancy_slab)),
            ];
            let _WidgetDataTotalOccupancy = [];
            for (let i = 0; i < uniqueStayDates.length; i++) {
                let objTO = {
                    StayDate: uniqueStayDates[i],
                    days_ahead: i,
                    occupancy_slab: "OCCUPANCY(%)",
                    avg_leadtime: 0,
                    avg_rate: 0,
                    total_roomnights: 0,
                    summary_value: "",
                    date_max_avg_leadtime: 0,
                    date_max_avg_rate: 0,
                    date_max_total_roomnights: 0,
                    ly_fc_Percentage: 0,
                    ly_fc_ADR: 0,
                    ly_fc_RMS: 0,
                };
                let avg_leadtime_count = 0;
                let avg_rate_count = 0;

                let f = WidgetData.filter(
                    (item) => item.StayDate === uniqueStayDates[i]
                );
                let _fcData = lyForecastData.find(
                    (item) => item.Dates === uniqueStayDates[i]
                );
                if (f && f.length > 0) {
                    for (let j = 0; j < f.length; j++) {
                        if (f[j].avg_leadtime && parseInt(f[j].avg_leadtime) > 0) {
                            avg_leadtime_count = avg_leadtime_count + 1;
                            objTO.avg_leadtime =
                                objTO.avg_leadtime + parseInt(f[j].avg_leadtime);
                            if (parseInt(f[j].avg_leadtime) > objTO.date_max_avg_leadtime) {
                                objTO.date_max_avg_leadtime = parseInt(f[j].avg_leadtime);
                            }
                        }

                        if (f[j].avg_rate && parseInt(f[j].avg_rate) > 0) {
                            avg_rate_count = avg_rate_count + 1;
                            objTO.avg_rate = objTO.avg_rate + parseInt(f[j].avg_rate);

                            if (parseInt(f[j].avg_rate) > objTO.date_max_avg_rate) {
                                objTO.date_max_avg_rate = parseInt(f[j].avg_rate);
                            }
                        }

                        if (f[j].total_roomnights) {
                            objTO.total_roomnights =
                                objTO.total_roomnights + parseInt(f[j].total_roomnights);

                            if (
                                parseInt(f[j].total_roomnights) >
                                objTO.date_max_total_roomnights
                            ) {
                                objTO.date_max_total_roomnights = parseInt(
                                    f[j].total_roomnights
                                );
                            }
                        }
                    }
                }

                if (objTO.avg_leadtime !== 0 && avg_leadtime_count !== 0) {
                    objTO.avg_leadtime = parseInt(
                        objTO.avg_leadtime / avg_leadtime_count
                    );
                }
                if (objTO.avg_rate !== 0 && avg_rate_count !== 0) {
                    objTO.avg_rate = parseInt(objTO.avg_rate / avg_rate_count);
                }

                objTO.ly_fc_Percentage = _fcData?.OccPerc ? _fcData?.OccPerc : 0;
                // objTO.ly_fc_ADR = _fcData?.ADR ? _fcData?.ADR : 0;
                objTO.ly_fc_RMS = _fcData?.RMS ? _fcData?.RMS : 0;

                _WidgetDataTotalOccupancy.push(objTO);
            }

            setWidgetDataStayDate(uniqueStayDates);
            setWidgetDataOccupancySlab(uniqueOccupancySlabs);
            setWidgetDataTotalOccupancy(_WidgetDataTotalOccupancy);
        }
    }, [WidgetData]);

    

    function LeadTimePercentileClass(leadtime, maxleadtime) {
        let ClassName = "level0";
        if (leadtime && leadtime !== 0 && maxleadtime && maxleadtime !== 0) {
            let per = parseInt((leadtime / maxleadtime) * 100);
            if (per > 80) {
                ClassName = "level1";
            } else if (per > 60) {
                ClassName = "level2";
            } else if (per > 40) {
                ClassName = "level3";
            } else if (per > 20) {
                ClassName = "level4";
            } else if (per > 0) {
                ClassName = "level5";
            }
        }
        return ClassName;
    }

    const [flagModal, setFlagModal] = useState(false);
    const [flagModalData, setFlagModalData] = useState({});
    const [FLAG_MECHANISM, setFLAG_MECHANISM] = useState([]);

    const getFLAG_MECHANISM = async () => {
        let startdate = new Date(para?.asOfDate);
        let enddate = new Date(para?.asOfDate);
        enddate = new Date(enddate.setDate(enddate.getDate() + DaysIntervals + 1));

        let List = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.FLAG_MECHANISM,
                body: {
                    asofdate: para?.asOfDate,
                    startdate: startdate,
                    enddate: enddate,
                    propertyCode: para?.propertyCode,
                },
            },
            false
        );

        let Response = apiResponse(false, List);

        if (Response?.isValidate) {
            setFLAG_MECHANISM(Response.data.data);
        }

        if (!Response?.isValidate) {
        }
    };

    const renderTooltip = (message, item) => (
        <Popover id="popover-id" className="tooltip-flag">
            <div className="m-2">{message}</div>
            <div className="d-flex justify-content-center mb-2">
                <Button id={commonService.generateGlobalClickTrackerID("PricingLadder", "ask-rm-copilot", item)}
                    onClick={() => {
                        setFlagModal(true);
                        setFlagModalData({
                            asofdate: para?.asOfDate,
                            dates: item,
                            propertycode: para?.propertyCode,
                        });
                    }}
                >
                    Ask RM Copilot
                </Button>
            </div>
        </Popover>
    );
    const [selectedMarketSegment, setSelectedMarketSegment] = useState([]);
    const [selectedTempMarketSegment, setSelectedTempMarketSegment] = useState([]);
    const [marketSegmentData, setMarketSegmentData] = useState([]);
    const multiselectRef = useRef(null);

    const handleApply = () => {
        setSelectedMarketSegment(selectedTempMarketSegment);

        const selectedMarketSegments = (selectedTempMarketSegment || [])
            .map((item) => item?.toString()?.trim())
            .filter(Boolean);

        const filteredOptions = selectedMarketSegments.length
            ? buildRateCodeOptions(
                ratePlanRawData.filter((item) => {
                    const marketSegmentValue = item?.marketsegment_term || item?.market_segmentation || "";
                    return selectedMarketSegments.some(
                        (segment) => marketSegmentValue?.toString().toUpperCase() === segment.toUpperCase()
                    );
                })
            )
            : buildRateCodeOptions(ratePlanRawData);

        const validSelections = (selectedRoomType || [])
            .map((item) => item?.toString()?.trim())
            .filter(Boolean)
            .filter((value) => filteredOptions.some((option) => option.value === value));

        const validTempSelections = (selectedTempRoomType || [])
            .map((item) => item?.toString()?.trim())
            .filter(Boolean)
            .filter((value) => filteredOptions.some((option) => option.value === value));

        setSelectedRoomType(validSelections);
        setSelectedTempRoomType(validTempSelections);

        multiselectRef.current.hide();
    };
    
    const [selectedRoomType, setSelectedRoomType] = useState([]);
    const [selectedTempRoomType, setSelectedTempRoomType] = useState([]);
    const [roomTypeData, setRoomTypeData] = useState([]);
    const roomTypeMultiselectRef = useRef(null);

    const handleRoomTypeApply = () => {
        setSelectedRoomType(selectedTempRoomType);
        roomTypeMultiselectRef.current.hide();
    };

    const [ratePlanRawData, setRatePlanRawData] = useState([]);

    const buildRateCodeOptions = (data) => {
        const uniqueOptions = [];
        const seen = new Set();

        (data || []).forEach((item) => {
            const rateCode = item?.ratecode?.toString()?.trim();
            if (!rateCode || seen.has(rateCode)) {
                return;
            }

            seen.add(rateCode);
            uniqueOptions.push({ label: rateCode, value: rateCode });
        });

        return uniqueOptions;
    };

    const getRatePlanList = async () => {
        let ratePlanListResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.REVENUE_RATE_PLAN.GET_LIST,
                body: {
                    pageNum: 1,
                    pageSize: 10,
                    sortColumn: "",
                    sortDirection: "asc",
                    searchValue: "",
                    propertyid: propertyDetailFromRTK.propertyid,
                    ratecode: "",
                    ratecodetype_term: "",
                    marketsegment_term: "",
                    isbarbased: null,
                },
            },
            false
        );

        let response = apiResponse(false, ratePlanListResponse);

        if (response?.isValidate) {
            const data = response?.data?.data || [];
            setRatePlanRawData(data);

            const allOptions = buildRateCodeOptions(data);
            setRoomTypeData(allOptions);
        } else {
            setRatePlanRawData([]);
            setRoomTypeData([]);
            setSelectedRoomType([]);
            setSelectedTempRoomType([]);
        }
    };

    const getTermListByProperty = async () => {
        setMarketSegmentData([])
        if (propertyDetailFromRTK) {
            let termListResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.Configuration +
                        API_URL.PROJECT_TERM.GET_LIST_BY_MULTIPLE_CATEGORY_AND_PROPERTY,
                    body: { categorynamebycomma: "Market Segment", propertyid: propertyDetailFromRTK.propertyid },
                },
                false
            );

            let response = apiResponse(false, termListResponse);

            if (response?.isValidate) {

                let data = response?.data?.data?.filter((f) => f.termcategoryname === "Market Segment");
                if (data) {
                    let lst = [];
                    data.map((item, index) => lst.push({ label: item.term, value: item.term }));
                    setMarketSegmentData(lst);
                }
            }
        }

    };

    useEffect(() => {
        if (!ratePlanRawData?.length) {
            setRoomTypeData([]);
            return;
        }

        const selectedMarketSegments = (selectedMarketSegment || [])
            .map((item) => item?.toString()?.trim())
            .filter(Boolean);

        const filteredOptions = selectedMarketSegments.length
            ? buildRateCodeOptions(
                ratePlanRawData.filter((item) => {
                    const marketSegmentValue = item?.marketsegment_term || item?.market_segmentation || "";
                    return selectedMarketSegments.some(
                        (segment) => marketSegmentValue?.toString().toUpperCase() === segment.toUpperCase()
                    );
                })
            )
            : buildRateCodeOptions(ratePlanRawData);

        setRoomTypeData(filteredOptions);
    }, [selectedMarketSegment, ratePlanRawData]);

    const footerTemplate = () => (
        <div style={{ padding: "0.5rem", textAlign: "right" }}>
            <Button id={commonService.generateGlobalClickTrackerID("PricingLadder", "apply", propertyCode)}
                onClick={handleApply}
            >Apply</Button>
        </div>
    );

    const roomTypeFooterTemplate = () => (
        <div style={{ padding: "0.5rem", textAlign: "right" }}>
            <Button id={commonService.generateGlobalClickTrackerID("PricingLadder", "apply-room-type", propertyCode)}
                onClick={handleRoomTypeApply}
            >Apply</Button>
        </div>
    );

    const getLastYearForecast = async () => {
        let startdate = new Date(para?.asOfDate);
        let enddate = new Date(para?.asOfDate);
        enddate = new Date(enddate.setDate(enddate.getDate() + DaysIntervals + 1));
        
        let lastYearResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.LAST_YEAR_AND_FORECAST.LAST_YEAR_AND_FORECAST,
                body: {
                    AsOfDate: para?.asOfDate,
                    startDate: commonService.getDateTimeInDBFormat(startdate),
                    endDate: commonService.getDateTimeInDBFormat(enddate),
                    propertyCode: para?.propertyCode,
                    ForcastType: propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term ? propertyDetailFromRTK?.revenuconfig[0]?.forcasttype_term.toLowerCase() : "ema",
                    propertyid: propertyDetailFromRTK?.propertyid,
                },
            },
            false
        );

        let response = apiResponse(false, lastYearResponse);

        if (response?.isValidate) {
            setLYForecastData(response?.data?.data);
        }

        if (!response?.isValidate) {
            setLYForecastData([]);
        }
    };

    useEffect(() => {
        if (api === 0) {
            setWidgetData([{ StayDate: "2025-10-10", occupancy_slab: "0-5%", days_ahead: 0, total_roomnights: "5", avg_rate: "108.87", avg_leadtime: "70.40", summary_value: "5/$108.87/70.40", }, { StayDate: "2025-10-10", occupancy_slab: "6-10%", days_ahead: 0, total_roomnights: "4", avg_rate: "112.10", avg_leadtime: "26.75", summary_value: "4/$112.10/26.75", }, { StayDate: "2025-10-10", occupancy_slab: "11-15%", days_ahead: 0, total_roomnights: "5", avg_rate: "105.76", avg_leadtime: "18.20", summary_value: "5/$105.76/18.20", }, { StayDate: "2025-10-10", occupancy_slab: "16-20%", days_ahead: 0, total_roomnights: "4", avg_rate: "101.78", avg_leadtime: "9.00", summary_value: "4/$101.78/9.00", }, { StayDate: "2025-10-10", occupancy_slab: "21-25%", days_ahead: 0, total_roomnights: "5", avg_rate: "78.74", avg_leadtime: "7.00", summary_value: "5/$78.74/7.00", }, { StayDate: "2025-10-10", occupancy_slab: "26-30%", days_ahead: 0, total_roomnights: "4", avg_rate: "84.37", avg_leadtime: "7.00", summary_value: "4/$84.37/7.00", }, { StayDate: "2025-10-10", occupancy_slab: "31-35%", days_ahead: 0, total_roomnights: "5", avg_rate: "77.39", avg_leadtime: "4.60", summary_value: "5/$77.39/4.60", }, { StayDate: "2025-10-10", occupancy_slab: "36-40%", days_ahead: 0, total_roomnights: "4", avg_rate: "116.75", avg_leadtime: "4.00", summary_value: "4/$116.75/4.00", }, { StayDate: "2025-10-10", occupancy_slab: "41-45%", days_ahead: 0, total_roomnights: "5", avg_rate: "138.80", avg_leadtime: "3.00", summary_value: "5/$138.80/3.00", }, { StayDate: "2025-10-10", occupancy_slab: "46-50%", days_ahead: 0, total_roomnights: "4", avg_rate: "123.23", avg_leadtime: "1.00", summary_value: "4/$123.23/1.00", }, { StayDate: "2025-10-10", occupancy_slab: "51-55%", days_ahead: 0, total_roomnights: "1", avg_rate: "79.49", avg_leadtime: "1.00", summary_value: "1/$79.49/1.00", }, { StayDate: "2025-10-10", occupancy_slab: "56-60%", days_ahead: 0, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-10", occupancy_slab: "61-65%", days_ahead: 0, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-10", occupancy_slab: "66-70%", days_ahead: 0, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-10", occupancy_slab: "71-75%", days_ahead: 0, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-10", occupancy_slab: "76-80%", days_ahead: 0, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-10", occupancy_slab: "81-85%", days_ahead: 0, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-10", occupancy_slab: "86-90%", days_ahead: 0, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-10", occupancy_slab: "91-95%", days_ahead: 0, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-10", occupancy_slab: "96-100%", days_ahead: 0, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-10", occupancy_slab: "101-105%", days_ahead: 0, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-10", occupancy_slab: "106-110%", days_ahead: 0, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-10", occupancy_slab: "111-115%", days_ahead: 0, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-10", occupancy_slab: "116-120%", days_ahead: 0, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-10", occupancy_slab: "121-125%", days_ahead: 0, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-11", occupancy_slab: "0-5%", days_ahead: 1, total_roomnights: "5", avg_rate: "114.18", avg_leadtime: "72.80", summary_value: "5/$114.18/72.80", }, { StayDate: "2025-10-11", occupancy_slab: "6-10%", days_ahead: 1, total_roomnights: "4", avg_rate: "101.54", avg_leadtime: "34.50", summary_value: "4/$101.54/34.50", }, { StayDate: "2025-10-11", occupancy_slab: "11-15%", days_ahead: 1, total_roomnights: "5", avg_rate: "119.55", avg_leadtime: "19.60", summary_value: "5/$119.55/19.60", }, { StayDate: "2025-10-11", occupancy_slab: "16-20%", days_ahead: 1, total_roomnights: "4", avg_rate: "85.80", avg_leadtime: "11.00", summary_value: "4/$85.80/11.00", }, { StayDate: "2025-10-11", occupancy_slab: "21-25%", days_ahead: 1, total_roomnights: "5", avg_rate: "85.71", avg_leadtime: "8.80", summary_value: "5/$85.71/8.80", }, { StayDate: "2025-10-11", occupancy_slab: "26-30%", days_ahead: 1, total_roomnights: "4", avg_rate: "93.97", avg_leadtime: "5.75", summary_value: "4/$93.97/5.75", }, { StayDate: "2025-10-11", occupancy_slab: "31-35%", days_ahead: 1, total_roomnights: "5", avg_rate: "99.63", avg_leadtime: "4.60", summary_value: "5/$99.63/4.60", }, { StayDate: "2025-10-11", occupancy_slab: "36-40%", days_ahead: 1, total_roomnights: "4", avg_rate: "137.19", avg_leadtime: "4.00", summary_value: "4/$137.19/4.00", }, { StayDate: "2025-10-11", occupancy_slab: "41-45%", days_ahead: 1, total_roomnights: "5", avg_rate: "124.61", avg_leadtime: "3.00", summary_value: "5/$124.61/3.00", }, { StayDate: "2025-10-11", occupancy_slab: "46-50%", days_ahead: 1, total_roomnights: "2", avg_rate: "82.87", avg_leadtime: "2.00", summary_value: "2/$82.87/2.00", }, { StayDate: "2025-10-11", occupancy_slab: "51-55%", days_ahead: 1, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-11", occupancy_slab: "56-60%", days_ahead: 1, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-11", occupancy_slab: "61-65%", days_ahead: 1, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-11", occupancy_slab: "66-70%", days_ahead: 1, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-11", occupancy_slab: "71-75%", days_ahead: 1, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-11", occupancy_slab: "76-80%", days_ahead: 1, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-11", occupancy_slab: "81-85%", days_ahead: 1, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-11", occupancy_slab: "86-90%", days_ahead: 1, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-11", occupancy_slab: "91-95%", days_ahead: 1, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-11", occupancy_slab: "96-100%", days_ahead: 1, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-11", occupancy_slab: "101-105%", days_ahead: 1, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-11", occupancy_slab: "106-110%", days_ahead: 1, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-11", occupancy_slab: "111-115%", days_ahead: 1, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-11", occupancy_slab: "116-120%", days_ahead: 1, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", }, { StayDate: "2025-10-11", occupancy_slab: "121-125%", days_ahead: 1, total_roomnights: "0", avg_rate: "0.00", avg_leadtime: "0.00", summary_value: "0/$0.00/0.00", },]);
        } else {
            if (para?.asOfDate) {
                getLastYearForecast()
                GetWidgetData();
            }
        }
    }, [para?.asOfDate, DaysIntervals, selectedMarketSegment, selectedRoomType]);

    useEffect(() => {
        getRatePlanList()
        getTermListByProperty();
    }, [propertyDetailFromRTK]);

    return (
        <div className="widget-container" style={{ position: "relative", padding: "0 5px" }}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("PricingLadder", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.id1,
                                    "PricingLadder",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("PricingLadder", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.PickupAnalysis,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("PricingLadder", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={tblids.id1}
                            onClick={() =>
                                commonService.fnExportInCSV(
                                    tblids.id1,
                                    `${para?.propertyCode}-PricingLadder-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                )
                            }
                        />
                    </Button>
                </div>
            )}
            <div className="width100per mb-2">
                <table>
                    <tr>
                        <td style={{ width: "100px" }}>
                            <select id={commonService.generateGlobalClickTrackerID("PricingLadder", "7-days", propertyCode)}
                                aria-label="Default select example"
                                class="form-select"
                                style={{ minWidth: "100px", height: "35px", fontSize: "13px" }}
                                onChange={(e) =>
                                    setDaysIntervals(parseInt(e.target.value))
                                }
                                value={DaysIntervals}
                            >
                                <option value="7">7 Days</option>
                                <option value="15">15 Days</option>
                                <option value="30">30 Days</option>
                                <option value="45">45 Days</option>
                                <option value="60">60 Days</option>
                                <option value="90">90 Days</option>
                            </select>
                        </td>
                        <td style={{ width: "250px" }}>
                            <MultiSelect id={commonService.generateGlobalClickTrackerID("PricingLadder", "multiselect-onchange", propertyCode)}
                                ref={multiselectRef}
                                filter
                                placeholder="Select Market Segment"
                                display="values"
                                selectedItemsLabel="{0} market segment selected"
                                maxSelectedLabels={0}
                                closeOnSelect={false}
                                value={selectedTempMarketSegment}
                                options={marketSegmentData}
                                onChange={(e) => {
                                    setSelectedTempMarketSegment(e.value);
                                }}
                                panelFooterTemplate={footerTemplate}
                            />
                            {/*<Form.Select*/}
                            {/*    aria-label="Default select example"*/}
                            {/*    name="marketsegment_term"*/}
                            {/*    values={MarketSegment}*/}
                            {/*    onChange={(e) => setMarketSegment(e.target.value)}*/}
                            {/*>*/}
                            {/*    <option value="">Select Market segment</option>*/}
                            {/*    {termByPropertyList?.map((item, index) => {*/}
                            {/*        if (*/}
                            {/*            item?.termcategoryname === "Market Segment"*/}
                            {/*        ) {*/}
                            {/*            return (*/}
                            {/*                <option key={index} value={item?.term}>*/}
                            {/*                    {item?.term}*/}
                            {/*                </option>*/}
                            {/*            );*/}
                            {/*        }*/}
                            {/*    })}*/}
                            {/*</Form.Select>*/}
                        </td>
                        <td style={{ width: "250px" }}>
                            <MultiSelect id={commonService.generateGlobalClickTrackerID("PricingLadder", "Room-Type-multiselect-onchange", propertyCode)} 
                                ref={roomTypeMultiselectRef}
                                filter
                                placeholder="Select Rate Code"
                                display="values"
                                selectedItemsLabel="{0} rate code selected"
                                maxSelectedLabels={0}
                                closeOnSelect={false}
                                value={selectedTempRoomType}
                                options={roomTypeData}
                                onChange={(e) => {
                                    setSelectedTempRoomType(e.value);
                                }}
                                panelFooterTemplate={roomTypeFooterTemplate}
                            />
                        </td>
                        <td style={{ width: "calc(100% - 700px)" }}>
                            <table>
                                <tr>
                                    <td>
                                        <p class="px-3  text-center text-red">AVG Rate Down</p>
                                    </td>
                                    <td>
                                        <p class="px-3 text-center text-green">AVG Rate Up</p>
                                    </td>
                                    <td>
                                        <p class="px-3 text-center" style={{ color: "#AFAFAF" }}>
                                            Recommended Rate
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </div>
            <div className="width100per">
                {DisplayLoading ? (
                    <Loader />
                ) : (
                    <div className="stripped__table width100per">
                        {WidgetDataStayDate &&
                            WidgetDataOccupancySlab &&
                            WidgetDataTotalOccupancy &&
                            WidgetDataStayDate.length > 0 &&
                            WidgetDataOccupancySlab.length > 0 &&
                            WidgetDataTotalOccupancy.length ? (
                            <div className="table-responsive tblDynamicPickupSticky">
                                <Table className="tbl_pricingladder">
                                    <thead className="tbl-header-sticky">
                                        <tr>
                                            <th className="stickycolumn" style={{ left: "0" }}>


                                            </th>

                                            {WidgetDataStayDate.map((item, index) => {
                                                let flagType = null;
                                                if (FLAG_MECHANISM && FLAG_MECHANISM.length > 0) {
                                                    let flagdata = FLAG_MECHANISM.filter(
                                                        (x) =>
                                                            moment(x.dates).format("YYYY-MM-DD") ===
                                                            moment(item).format("YYYY-MM-DD")
                                                    );
                                                    if (flagdata && flagdata.length > 0) {
                                                        if (flagdata[0]?.demandtag) {
                                                            if (
                                                                flagdata[0]?.demandtag.toUpperCase().replaceAll(" ", "") ===
                                                                "HIGH"
                                                            ) {
                                                                flagType = (
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        delay={{ show: 250, hide: 2000 }}
                                                                        overlay={renderTooltip(
                                                                            flagdata[0]?.message,
                                                                            item
                                                                        )}
                                                                    >
                                                                        <img
                                                                            src={DemandScore_High}
                                                                            alt=""
                                                                            style={{ height: "11px", width: "11px" }}
                                                                        />
                                                                    </OverlayTrigger>
                                                                );
                                                            } else if (
                                                                flagdata[0]?.demandtag.toUpperCase().replaceAll(" ", "") === "LOW"
                                                            ) {
                                                                flagType = (
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        delay={{ show: 250, hide: 2000 }}
                                                                        message={flagdata[0]?.message}
                                                                        overlay={renderTooltip(
                                                                            flagdata[0]?.message,
                                                                            item
                                                                        )}
                                                                    >
                                                                        <img
                                                                            src={DemandScore_Low}
                                                                            alt=""
                                                                            style={{ height: "11px", width: "11px" }}
                                                                        />
                                                                    </OverlayTrigger>
                                                                );
                                                            } else if (
                                                                flagdata[0]?.demandtag.toUpperCase().replaceAll(" ", "") ===
                                                                "MODERATE"
                                                            ) {
                                                                flagType = (
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        delay={{ show: 250, hide: 2000 }}
                                                                        message={flagdata[0]?.message}
                                                                        overlay={renderTooltip(
                                                                            flagdata[0]?.message,
                                                                            item
                                                                        )}
                                                                    >
                                                                        <img
                                                                            src={DemandScore_Moderate}
                                                                            alt=""
                                                                            style={{ height: "11px", width: "11px" }}
                                                                        />
                                                                    </OverlayTrigger>
                                                                );
                                                            } else if (
                                                                flagdata[0]?.demandtag.toUpperCase().replaceAll(" ", "") ===
                                                                "VERYHIGH"
                                                            ) {
                                                                flagType = (
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        delay={{ show: 250, hide: 2000 }}
                                                                        message={flagdata[0]?.message}
                                                                        overlay={renderTooltip(
                                                                            flagdata[0]?.message,
                                                                            item
                                                                        )}
                                                                    >
                                                                        <img
                                                                            src={DemandScore_VeryHigh}
                                                                            alt=""
                                                                            style={{ height: "11px", width: "11px" }}
                                                                        />
                                                                    </OverlayTrigger>
                                                                );
                                                            } else if (
                                                                flagdata[0]?.demandtag.toUpperCase().replaceAll(" ", "") ===
                                                                "VERYLOW"
                                                            ) {
                                                                flagType = (
                                                                    <OverlayTrigger
                                                                        placement="right"
                                                                        delay={{ show: 250, hide: 2000 }}
                                                                        message={flagdata[0]?.message}
                                                                        overlay={renderTooltip(
                                                                            flagdata[0]?.message,
                                                                            item
                                                                        )}
                                                                    >
                                                                        <img
                                                                            src={DemandScore_VeryLow}
                                                                            alt=""
                                                                            style={{ height: "11px", width: "11px" }}
                                                                        />
                                                                    </OverlayTrigger>
                                                                );
                                                            }
                                                        }
                                                    }
                                                }

                                                return (
                                                    <th className="width150">
                                                        <>{flagType && flagType}</>{" "}
                                                        <>
                                                            {commonService.getDateInFormat(item)}{" "}
                                                            {moment(item).format("ddd")}
                                                        </>
                                                    </th>
                                                );
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="stickycolumn" style={{ left: "0", zIndex: "1" }}>OCCUPANCY(%)</td>
                                            {WidgetDataTotalOccupancy.map((TO, OSindex) => (
                                                <td>
                                                    <table className="tblcelldata">
                                                        <tr>
                                                            <td id={commonService.generateGlobalClickTrackerID("PricingLadder", "rooms", TO)}
                                                                className="pe-0"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={(event) => {
                                                                    if (TO.total_roomnights > 0) {
                                                                        setModelData(TO);
                                                                        let Position = "bottom";
                                                                        let Top = event.nativeEvent.layerY - 2;
                                                                        if (Top + 400 > window.innerHeight) {
                                                                            Position = "top";
                                                                        }
                                                                        setModelView({
                                                                            IsDisplay: true,
                                                                            Target: event.target,
                                                                            Position: Position,
                                                                        });
                                                                    }
                                                                }}
                                                            >
                                                                <span>
                                                                    <b>{TO.total_roomnights}</b> <small> RMS</small>
                                                                    {" "}(<small><b>{TO.avg_leadtime}</b>  Days</small>)
                                                                </span>
                                                            </td>
                                                            <td rowSpan="2" className="text-end">
                                                                <label
                                                                    className="avg_rate"
                                                                    data-val={TO.avg_rate}
                                                                >
                                                                    {commonService.formateAmount(TO.avg_rate)}
                                                                </label>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            {/* <td><b>{TO.ly_fc_ADR}</b> <small> FC </small></td> */}
                                                            <td><b>{TO.ly_fc_RMS}</b> <small> Forecast RMS </small></td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            ))}
                                        </tr>
                                        {WidgetDataOccupancySlab.map((OS, OSindex) => {
                                            return (
                                                <tr>
                                                    <td className="stickycolumn" style={{ left: "0", zIndex: "1" }}>{OS}</td>
                                                    {WidgetDataStayDate.map((SD, SDindex) => {
                                                        let OccData;
                                                        if (OSindex === 0) {
                                                            OccData = WidgetDataTotalOccupancy?.find(
                                                                (data) => data?.StayDate === SD
                                                            )?.avg_rate;
                                                        } else {
                                                            OccData = WidgetData.find(
                                                                (d) =>
                                                                    d.StayDate === SD &&
                                                                    d.occupancy_slab ===
                                                                    WidgetDataOccupancySlab[OSindex - 1]
                                                            )?.avg_rate;
                                                        }

                                                        let fd = WidgetData.filter(
                                                            (d) =>
                                                                d.StayDate === SD && d.occupancy_slab === OS
                                                        );
                                                        let avg_leadtime = 0; // Days
                                                        let avg_rate = 0; // RATE
                                                        let total_roomnights = 0; // ROOM
                                                        let recommended_rate = 0;

                                                        if (fd && fd.length > 0) {
                                                            if (fd[0].avg_leadtime)
                                                                avg_leadtime = parseInt(fd[0].avg_leadtime);

                                                            if (fd[0].avg_rate)
                                                                avg_rate = parseInt(fd[0].avg_rate);

                                                            if (fd[0].total_roomnights)
                                                                total_roomnights = parseInt(
                                                                    fd[0].total_roomnights
                                                                );

                                                            if (fd[0].recommended_rate)
                                                                recommended_rate = parseInt(
                                                                    fd[0].recommended_rate
                                                                );
                                                        }

                                                        let fdt = WidgetDataTotalOccupancy.filter(
                                                            (d) => d.StayDate === SD
                                                        );
                                                        let date_max_avg_leadtime = 0;
                                                        if (fdt && fdt.length > 0) {
                                                            if (fdt[0].date_max_avg_leadtime)
                                                                date_max_avg_leadtime = parseInt(
                                                                    fdt[0].date_max_avg_leadtime
                                                                );
                                                        }
                                                        const isEmptyData =
                                                            avg_leadtime === 0 &&
                                                            avg_rate === 0 &&
                                                            total_roomnights === 0;

                                                        const nextSlab =
                                                            WidgetDataOccupancySlab[OSindex + 1];
                                                        let nextFd = WidgetData.filter(
                                                            (d) =>
                                                                d.StayDate === SD &&
                                                                d.occupancy_slab === nextSlab
                                                        );

                                                        const nextAvgLead = nextFd?.[0]?.avg_leadtime
                                                            ? parseInt(nextFd[0].avg_leadtime)
                                                            : 0;
                                                        const nextAvgRate = nextFd?.[0]?.avg_rate
                                                            ? parseInt(nextFd[0].avg_rate)
                                                            : 0;
                                                        const nextTotalRooms = nextFd?.[0]?.total_roomnights
                                                            ? parseInt(nextFd[0].total_roomnights)
                                                            : 0;

                                                        const shouldMarkCurrent =
                                                            nextAvgLead === 0 &&
                                                            nextAvgRate === 0 &&
                                                            nextTotalRooms === 0;

                                                        const percentValue = fdt?.[0]?.ly_fc_Percentage;
                                                        const [minPercent, maxPercent] = OS
                                                            .replaceAll("%", "")
                                                            .split("-")
                                                            .map((val) => parseInt(val, 10));

                                                        const shouldHighlight =
                                                            typeof percentValue === "number" &&
                                                            !Number.isNaN(minPercent) &&
                                                            !Number.isNaN(maxPercent) &&
                                                            percentValue >= minPercent &&
                                                            percentValue <= maxPercent;

                                                        return (
                                                            <td className={shouldHighlight ? "box-heilight" : ""}>
                                                                <table
                                                                    className={`tblcelldata 
                                                                    ${LeadTimePercentileClass(
                                                                        avg_leadtime,
                                                                        date_max_avg_leadtime
                                                                    )} 
                                                                    ${!isEmptyData && shouldMarkCurrent
                                                                        ? `${avg_rate > OccData
                                                                            ? "lastelement-success"
                                                                            : "lastelement-danger"
                                                                        }`
                                                                    : ""} 
                                                                    ${total_roomnights > 0
                                                                            ? "avgrate"
                                                                            : "recommendedrate"
                                                                        }`
                                                                    }
                                                                >
                                                                    <tr>
                                                                        <td id={commonService.generateGlobalClickTrackerID("PricingLadder", "td-onclick", SD)}
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={(event) => {
                                                                                if (total_roomnights > 0) {
                                                                                    setModelData(fd[0]);
                                                                                    let Position = "bottom";
                                                                                    let Top =
                                                                                        event.nativeEvent.layerY - 2;
                                                                                    if (Top + 400 > window.innerHeight) {
                                                                                        Position = "top";
                                                                                    }
                                                                                    setModelView({
                                                                                        IsDisplay: true,
                                                                                        Target: event.target,
                                                                                        Position: Position,
                                                                                    });
                                                                                }
                                                                            }}
                                                                        >
                                                                            {total_roomnights > 0
                                                                                ? total_roomnights + " Rooms"
                                                                                : ""}
                                                                        </td>
                                                                        <td
                                                                            rowSpan="2"
                                                                            style={{ cursor: "pointer" }}
                                                                            className="text-end"
                                                                            title={
                                                                                total_roomnights > 0
                                                                                    ? "Avg Rate"
                                                                                    : "Recommended Rate"
                                                                            }
                                                                        >
                                                                            <label id={commonService.generateGlobalClickTrackerID("PricingLadder", "label-onclick", SD)}
                                                                                className={`avg_rate ${avg_rate !== 0
                                                                                    ? avg_rate > OccData
                                                                                        ? "text-green"
                                                                                        : "text-red"
                                                                                    : ""
                                                                                    }`}
                                                                                data-val={avg_rate}
                                                                                onClick={(event) => {
                                                                                    setModelData(fd[0]);
                                                                                    let Position = "bottom";
                                                                                    let Top =
                                                                                        event.nativeEvent.layerY - 2;
                                                                                    if (Top + 400 > window.innerHeight) {
                                                                                        Position = "top";
                                                                                    }
                                                                                    setRateModelView({
                                                                                        IsDisplay: true,
                                                                                        Target: event.target,
                                                                                        Position: Position,
                                                                                    });
                                                                                }}
                                                                                data-condition={
                                                                                    avg_rate + " > " + OccData
                                                                                }
                                                                            >
                                                                                {commonService.formateAmount(
                                                                                    total_roomnights > 0
                                                                                        ? avg_rate
                                                                                        : recommended_rate
                                                                                )}{" "}
                                                                                <>
                                                                                    {avg_rate !== 0 ? (
                                                                                        avg_rate > OccData ? (
                                                                                            <img src={trendingup} alt="UP" />
                                                                                        ) : (
                                                                                            <img
                                                                                                src={trendingdown}
                                                                                                alt="DOWN"
                                                                                            />
                                                                                        )
                                                                                    ) : (
                                                                                        ""
                                                                                    )}
                                                                                </>
                                                                            </label>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>
                                                                            {avg_leadtime > 0 || avg_rate > 0
                                                                                ? avg_leadtime + " Days"
                                                                                : ""}{" "}
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>

                                <Table
                                    responsive
                                    className="tbl_pricingladder"
                                    id={tblids.id1}
                                    style={{ display: "none" }}
                                >
                                    <thead>
                                        <tr>
                                            <th rowSpan="2">Days</th>
                                            {WidgetDataStayDate.map((item, index) => {
                                                return (
                                                    <th className="width150">
                                                        <>{commonService.getDateInFormat(item)}</>
                                                    </th>
                                                );
                                            })}
                                        </tr>
                                        <tr>
                                            {WidgetDataStayDate.map((item, index) => {
                                                return (
                                                    <th className="width150">
                                                        <table className="tblcelldata">
                                                            <tr>
                                                                <th style={{ cursor: "pointer" }}>
                                                                    Room Nights
                                                                </th>
                                                                <th>Lead Time</th>
                                                                <th className="text-end">AVG Rate</th>
                                                                <th>Recommended Rate</th>
                                                            </tr>
                                                        </table>
                                                    </th>
                                                );
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>OCCUPANCY(%)</td>
                                            {WidgetDataTotalOccupancy.map((TO, OSindex) => (
                                                <td>
                                                    <table className="tblcelldata">
                                                        <tr>
                                                            <td style={{ cursor: "pointer" }}>
                                                                {TO.total_roomnights} Rooms
                                                            </td>
                                                            <td>{TO.avg_leadtime} Days</td>
                                                            <td className="text-end">
                                                                <label
                                                                    className="avg_rate"
                                                                    data-val={TO.avg_rate}
                                                                >
                                                                    {commonService.formateAmount(TO.avg_rate)}
                                                                </label>
                                                            </td>

                                                            <td></td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            ))}
                                        </tr>
                                        {WidgetDataOccupancySlab.map((OS, OSindex) => {
                                            return (
                                                <tr>
                                                    <td>{OS}</td>
                                                    {WidgetDataStayDate.map((SD, SDindex) => {
                                                        let OccData;
                                                        if (OSindex === 0) {
                                                            OccData = WidgetDataTotalOccupancy?.find(
                                                                (data) => data?.StayDate === SD
                                                            )?.avg_rate;
                                                        } else {
                                                            OccData = WidgetData.find(
                                                                (d) =>
                                                                    d.StayDate === SD &&
                                                                    WidgetDataOccupancySlab[OSindex - 1]
                                                            )?.avg_rate;
                                                        }

                                                        let fd = WidgetData.filter(
                                                            (d) =>
                                                                d.StayDate === SD && d.occupancy_slab === OS
                                                        );
                                                        let avg_leadtime = 0; // Days
                                                        let avg_rate = 0; // RATE
                                                        let total_roomnights = 0; // ROOM
                                                        let recommended_rate = 0;

                                                        if (fd && fd.length > 0) {
                                                            if (fd[0].avg_leadtime)
                                                                avg_leadtime = parseInt(fd[0].avg_leadtime);

                                                            if (fd[0].avg_rate)
                                                                avg_rate = parseInt(fd[0].avg_rate);

                                                            if (fd[0].total_roomnights)
                                                                total_roomnights = parseInt(
                                                                    fd[0].total_roomnights
                                                                );

                                                            if (fd[0].recommended_rate)
                                                                recommended_rate = parseInt(
                                                                    fd[0].recommended_rate
                                                                );
                                                        }

                                                        let fdt = WidgetDataTotalOccupancy.filter(
                                                            (d) => d.StayDate === SD
                                                        );
                                                        let date_max_avg_leadtime = 0;
                                                        if (fdt && fdt.length > 0) {
                                                            if (fdt[0].date_max_avg_leadtime)
                                                                date_max_avg_leadtime = parseInt(
                                                                    fdt[0].date_max_avg_leadtime
                                                                );
                                                        }
                                                        const isEmptyData =
                                                            avg_leadtime === 0 &&
                                                            avg_rate === 0 &&
                                                            total_roomnights === 0;

                                                        const nextSlab =
                                                            WidgetDataOccupancySlab[OSindex + 1];
                                                        let nextFd = WidgetData.filter(
                                                            (d) =>
                                                                d.StayDate === SD &&
                                                                d.occupancy_slab === nextSlab
                                                        );

                                                        const nextAvgLead = nextFd?.[0]?.avg_leadtime
                                                            ? parseInt(nextFd[0].avg_leadtime)
                                                            : 0;
                                                        const nextAvgRate = nextFd?.[0]?.avg_rate
                                                            ? parseInt(nextFd[0].avg_rate)
                                                            : 0;
                                                        const nextTotalRooms = nextFd?.[0]?.total_roomnights
                                                            ? parseInt(nextFd[0].total_roomnights)
                                                            : 0;

                                                        const shouldMarkCurrent =
                                                            nextAvgLead === 0 &&
                                                            nextAvgRate === 0 &&
                                                            nextTotalRooms === 0;

                                                        return (
                                                            <td>
                                                                <table
                                                                    className={`tblcelldata ${LeadTimePercentileClass(
                                                                        avg_leadtime,
                                                                        date_max_avg_leadtime
                                                                    )} ${!isEmptyData && shouldMarkCurrent
                                                                        ? `${avg_rate > OccData
                                                                            ? "lastelement-success"
                                                                            : "lastelement-danger"
                                                                        }`
                                                                        : ""
                                                                        } ${total_roomnights > 0
                                                                            ? "avgrate"
                                                                            : "recommendedrate"
                                                                        }`}
                                                                >
                                                                    <tr>
                                                                        <td style={{ cursor: "pointer" }}>
                                                                            {total_roomnights > 0
                                                                                ? total_roomnights + " Rooms"
                                                                                : ""}
                                                                        </td>
                                                                        <td>
                                                                            {avg_leadtime > 0 || avg_rate > 0
                                                                                ? avg_leadtime + " Days"
                                                                                : ""}{" "}
                                                                        </td>
                                                                        <td
                                                                            style={{ cursor: "pointer" }}
                                                                            className="text-end"
                                                                            title={
                                                                                total_roomnights > 0
                                                                                    ? "AVG Rate"
                                                                                    : "Recommended Rate"
                                                                            }
                                                                        >
                                                                            <label
                                                                                className={`avg_rate ${avg_rate !== 0
                                                                                    ? avg_rate > OccData
                                                                                        ? "text-green"
                                                                                        : "text-red"
                                                                                    : ""
                                                                                    }`}
                                                                                data-val={avg_rate}
                                                                            >
                                                                                {commonService.formateAmount(
                                                                                    total_roomnights > 0
                                                                                        ? avg_rate
                                                                                        : recommended_rate
                                                                                )}{" "}
                                                                                <>
                                                                                    {avg_rate !== 0 ? (
                                                                                        avg_rate > OccData ? (
                                                                                            <img src={trendingup} alt="UP" />
                                                                                        ) : (
                                                                                            <img
                                                                                                src={trendingdown}
                                                                                                alt="DOWN"
                                                                                            />
                                                                                        )
                                                                                    ) : (
                                                                                        ""
                                                                                    )}
                                                                                </>
                                                                            </label>
                                                                        </td>

                                                                        <td>
                                                                            {commonService.formateAmount(
                                                                                recommended_rate
                                                                            )}{" "}
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                )}
            </div>
            {api !== 0 && (
                <Comments widgetDetails={para} editorId={"PricingLadder"} />
            )}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}

            <Overlay
                show={modelView.IsDisplay}
                target={modelView.Target}
                placement={modelView.Position}
                rootClose
                onHide={() =>
                    setModelView({
                        IsDisplay: false,
                        Target: null,
                        Position: "bottom",
                    })
                }
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                    style={{ zIndex: 999999 }}
                >
                    <div className="horizontal-menu-option active">
                        <PricingModel
                            closeModal={() =>
                                setModelView({
                                    IsDisplay: false,
                                    Target: null,
                                    Position: "bottom",
                                })
                            }
                            data={modelData}
                            para={para}
                            marketsegment={selectedMarketSegment ? selectedMarketSegment.join(",") : ""}
                            marketsegment={selectedMarketSegment ? selectedMarketSegment.join(",") : ""}
                            ratecode={selectedRoomType ? selectedRoomType.join(",") : ""}
                        />
                    </div>
                </Popover>
            </Overlay>

            <Overlay
                show={rateModelView.IsDisplay}
                target={rateModelView.Target}
                placement={rateModelView.Position}
                rootClose
                onHide={() =>
                setRateModelView({
                    IsDisplay: false,
                    Target: null,
                    Position: "bottom",
                })
                }
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                    style={{ zIndex: 999999 }}
                >
                    <div className="horizontal-menu-option active">
                        <RateModel
                            closeModal={() =>
                                setRateModelView({
                                    IsDisplay: false,
                                    Target: null,
                                    Position: "bottom",
                                })
                            }
                            data={modelData}
                            para={para}
                        />
                    </div>
                </Popover>
            </Overlay>

            {flagModal && (
                <FlagPopup
                    showModal={flagModal}
                    closeModal={() => setFlagModal(false)}
                    data={flagModalData}
                />
            )}
        </div>
    );
};

export default PricingLadder;
